import React from 'react';
import { pureRender } from 'epic-alt-utils';
import autobind from 'core-decorators/lib/autobind';
import './ctaButton.sass';

@pureRender
export default class CtaButton extends React.Component {

    @autobind
    onClick(e) {
        const cta = this.props.cta;
        if (cta && cta.onClick && typeof cta.onClick === 'function') {
            cta.onClick(e);
        }
    }

    render() {
        const config = this.props.cta || {};
        const label = config.title || '';
        const href = config.href || '#';

        return (
            <div className="cta accent-bg-color accent-bg-color-hover" id="cta">
                <a href={href} onClick={this.onClick} className="accent-bg-color accent-bg-color-hover" title={label}>
                    <span className="accent-text-color accent-text-color-hover">{label}</span>
                </a>
            </div>
        );
    }
}

CtaButton.propTypes = {
    cta: React.PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/ctaButton/CtaButton.js
 **/